const options = {
    breakPoint: 960,
};

export default options;
